import { Howl } from 'howler'

import { is } from '@common/is/is'

/**
 * Howl audio példányosítása, elkérése.
 * @param src    - Hangforrás elérési útvonala.
 * @param volume - Hangforrás default hangereje.
 */
export default async function getAudio (src: string, volume?: number): Promise<Howl | undefined> {
  return new Promise((resolve) => {
    let audio: Howl

    /**
     * Howl, vagy undefined visszaküldése.
     * @param dt - Visszaküldendő Howl vagy null.
     */
    function send (dt: Howl | undefined = audio): void {
      resolve(dt)
    }

    audio = new Howl({
      src: [ src ],
      ...is.number(volume) ? { volume } : {},
      onload: () => {
        send()
      },
      onloaderror: (soundId, error) => {
        // eslint-disable-next-line no-console
        console.log('onloaderror', soundId, error)

        send()
      }
    })
  })
}
